import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../../services/api';
import './AuthForms.css';

export const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const verifyEmail = useCallback(async (token: string) => {
    try {
      const response = await authApi.verifyEmail(token);
      setSuccess(response.message);
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/app/login');
      }, 3000);
    } catch (error: any) {
      setError(error.response?.data?.error || 'Failed to verify email');
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token);
    } else {
      setError('Invalid verification link');
      setIsLoading(false);
    }
  }, [searchParams, verifyEmail]);

  const handleBackToLogin = () => {
    navigate('/app/login');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-form">
          <div className="auth-header">
            <h2>
              <span className="logo-accent">todo</span>
              <span>bananowe.it</span>
            </h2>
            <p>Email Verification</p>
          </div>

          <div className="auth-form-content">
            {isLoading && (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <p style={{ color: '#fff', marginBottom: '16px' }}>Verifying your email...</p>
                <div style={{ 
                  width: '32px', 
                  height: '32px', 
                  border: '3px solid rgba(226, 183, 20, 0.3)',
                  borderTop: '3px solid #e2b714',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  margin: '0 auto'
                }}></div>
              </div>
            )}

            {error && (
              <div className="auth-error">
                {error}
              </div>
            )}

            {success && (
              <div className="auth-success">
                {success}
                <p style={{ marginTop: '12px', fontSize: '14px' }}>
                  Redirecting to login page in 3 seconds...
                </p>
              </div>
            )}

            {!isLoading && (
              <button 
                type="button" 
                className="auth-secondary-btn"
                onClick={handleBackToLogin}
                style={{ marginTop: '20px' }}
              >
                Back to Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 